import "./style.scss";
import "./style-mob.scss";
import React, { FC, useEffect, useState } from "react";
import FormApplicationMobile from "./SubComponents/FormApplicationMobile";
import FormApplicationDopInfo from "./SubComponents/FormApplicationDopInfo";
import FormApplicationProgram from "./SubComponents/FormApplicationProgram";
import FormApplicationFast from "./SubComponents/FormApplicationFast";
import { IFormApplicationProps } from "@/src/types/IApplyOnline";

const FormApplication: FC<IFormApplicationProps> = (props) => {
  const { register, control, errors, handleSubmit, setValue, selectedFilesMap, setSelectedFilesMap, isSubmitDisabled } = props;

  const [fileModalIsActive, setFileModalIsActive] = useState<boolean>(false);

  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const width = window.innerWidth;
    setIsMobile(width <= 767);
  }, []);

  const handleClickDocument = (action: "open" | "close") => {
    setFileModalIsActive(action === "open");
    document.body.classList.toggle("hidden", action === "open");
  };

  const handleFocus = (el: string) => {
    const allStepTitles = document.querySelectorAll(".apply-online-step-title");
    allStepTitles.forEach((el) => el.classList.remove("active"));

    const targetStepTitle = document.querySelector(`.apply-online-step-title.${el}`);
    const targetStep = document.querySelector(`.apply-online-step-point.${el}`);
    if (targetStepTitle && targetStep) {
      targetStepTitle.classList.add("active");
      targetStep.classList.add("isWasEmpty");
    }
  };

  return (
    <div className="form-application">
      {isMobile ? (
        <FormApplicationMobile
          register={register}
          control={control}
          errors={errors}
          handleSubmit={handleSubmit}
          setValue={setValue}
          selectedFilesMap={selectedFilesMap}
          setSelectedFilesMap={setSelectedFilesMap}
          isSubmitDisabled={isSubmitDisabled}
          fileModalIsActive={fileModalIsActive}
          handleClickDocument={handleClickDocument}
          handleFocus={handleFocus}
        />
      ) : (
        <>
          <FormApplicationFast register={register} control={control} errors={errors} handleFocus={() => handleFocus("one")} />
          <FormApplicationDopInfo register={register} control={control} errors={errors} handleFocus={() => handleFocus("two")} />
          <FormApplicationProgram register={register} control={control} errors={errors} handleFocus={() => handleFocus("three")} />
        </>
      )}
    </div>
  );
};

export default FormApplication;
